import React, {useEffect, useState} from 'react';

import {Row} from '../../../components/layout';
import './styles.scss';
import {connect} from 'react-redux';
import {compose} from 'redux';

interface BubbleProps {
  globalStyles: any;
  classNames: any;
  width?: any;
  height?: any;
}

function Bubble({globalStyles, classNames, width, height}: BubbleProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  return (
    <Row className={classNames}>
      <svg
        width={width ? width : windowWidth <= 768 ? '180px' : '140px'}
        height={height ? height : windowWidth <= 768 ? '180px' : '140px'}
        viewBox="0 0 420 420"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>elements_services/bubble</title>
        <defs>
          <linearGradient
            x1="0%"
            y1="5.41214059%"
            x2="103.325195%"
            y2="94.5878594%"
            id="linearGradient-1">
            <stop stopColor={globalStyles.primaryColor} offset="0%"></stop>
            {/* <stop stopColor="#00DFE9" offset="0%"></stop> */}
            <stop stopColor={globalStyles.primaryColor} offset="100%"></stop>
          </linearGradient>
        </defs>
        <g
          id="elements_services/bubble"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd">
          <path
            d="M226.83486,388.595336 C325.16147,386.918761 399.812357,318.75056 402.910306,224.978646 C406.008255,131.206733 328.672636,15.7694723 199.321554,45.8534909 C137.693171,60.186803 43.0493875,101.213449 35.2791863,218.682696 C27.5089852,336.151944 128.508249,390.271911 226.83486,388.595336 Z"
            id="Bubble"
            fill="url(#linearGradient-1)"
            fillRule="nonzero"
            transform="translate(218.928826, 214.809353) scale(-1, 1) translate(-218.928826, -214.809353) "></path>
          <path
            d="M207.544543,400.962541 C305.137372,399.299219 379.231164,331.669897 382.305994,238.639264 C385.380824,145.608631 308.622336,31.0839173 180.23656,60.9301175 C119.06809,75.1501228 25.1306039,115.852447 17.4183893,232.393084 C9.7061747,348.933722 109.951713,402.625862 207.544543,400.962541 Z"
            id="Bubble2"
            fill={globalStyles.primaryColor}
            opacity="0.456798735"
            style={{mixBlendMode: 'multiply'}}
            transform="translate(199.697509, 228.550360) scale(-1, -1) translate(-199.697509, -228.550360) "></path>
        </g>
      </svg>
    </Row>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(Bubble));
